<template>
    <b-card class="testimonial-card">
        <b-img slot="header" class="icon" :src="src" :alt="alt"></b-img>

        <h5 class="name">{{name}}</h5>
        <div class="job">{{job}}</div>
        <div class="text">
            <span class="float-left" v-tr>"|« </span><slot></slot><span v-tr>"| »</span>
        </div>
        <template slot="footer" v-if="clientSince">
            <span v-tr>Client since |Client depuis </span> {{clientSince}}
        </template>
    </b-card>
</template>

<script>
    export default {
        name: `testimonial-card`,
        props: {
            src: { type: String, required: true },
            alt: { type: String },
            name: { type: String, required: true },
            job: { type: String, required: true },
            clientSince: { type: String, required: false }
        }
    }
</script>

<style lang="scss" scoped>
    .testimonial-card {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        text-align: left;
        width: 350px;
        margin: 10px;
        letter-spacing: 1px;
        font-size: 9pt;
        text-decoration: none !important;
        color: #333;
        border-radius: 15px;

        .card-header {
            padding: 0;
            border: none;
            width: 100%;
        }

        img {
            position: relative;
            width: 100%;
            height: 170px;
            object-fit: cover;
            //background-color: #fafafa;
            //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }

        .card-body {
            padding: 10px;
        }

        h5 {
            margin-top: 0;
            font-size: 12pt;
            font-weight: 600;
        }

        .job {
            color: #777;
        }

        .text {
            margin-top: 8px;
            width: 100%;
            font-weight: 500;
            text-align: justify;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .card-footer {
            padding: 10px;
            background: none;
        }
    }

    @media(max-width: 576px) {
        .testimonial-card {
            width: 100%;
            margin: 5px;

            .card-header {
                text-align: center;

                img {
                    margin: 0 auto;
                    position: relative;
                    width: 110px;
                    height: 54px;
                }
            }
        }
    }
</style>
